import React from 'react';

// Types
import { FormTypeType, ReviewFormTemplateType, TextareaQuestionType } from 'Shared/types/ReviewFormTemplate.type';

// Hoooks
import { useQuestion } from './use-question';

// Components
import QuestionWrapper from './QuestionWrapper';

type Props = {
  question: TextareaQuestionType;
  onChange: Function;
  handleDeleteQuestion: Function;
  handleDuplicateQuestion: Function;
  activeQuestionKey: string;
  setActiveQuestionKey: Function;
  handleMoveQuestion: Function;
  reviewFormType: FormTypeType;
  reviewFormTemplates: ReviewFormTemplateType[];
};

const TitleDescriptionQuestion = ({
  question,
  onChange,
  handleDeleteQuestion,
  handleDuplicateQuestion,
  activeQuestionKey,
  setActiveQuestionKey,
  handleMoveQuestion,
  reviewFormType,
  reviewFormTemplates,
}: Props) => {
  const { handleUpdateQuestion } = useQuestion({ question, onChange });

  return (
    <QuestionWrapper
      question={question}
      onChange={handleUpdateQuestion}
      handleDeleteQuestion={handleDeleteQuestion}
      activeQuestionKey={activeQuestionKey}
      setActiveQuestionKey={setActiveQuestionKey}
      handleDuplicateQuestion={handleDuplicateQuestion}
      handleMoveQuestion={handleMoveQuestion}
      reviewFormType={reviewFormType}
      reviewFormTemplates={reviewFormTemplates}
    />
  );
};

export default TitleDescriptionQuestion;
